import { Moment } from "moment";
import { LookupFields, UrlFields, UserFields } from "src/modules/modules.type";
import { LookUpRecord, UserRecord } from "src/types/main";
import {
  notificationsListFields,
  NotificationsListFieldsRecordType,
  NotificationsListFieldsType,
} from "./notifications.config";

import { emailListFields, EmailListFieldsRecordType, EmailListFieldsType } from "./email.config";
import {
  myTaskMeetingsMainListFields,
  MyTaskMeetingsMainListFieldsRecordType,
  MyTaskMeetingsMainListFieldsType,
} from "./meetings.config";
import { FIELDS_TYPES } from "./type.config";

import {
  MyGoslistNameFields,
  MyGoslistNameFieldsRecordType,
  MyGoslistNameFieldsType,
} from "src/pages/DashboardPage/gos/api/config/gos.config";
import {
  myVPOActionListNameFields,
  myVPOActionListNameFieldsRecordType,
  myVPOActionListNameFieldsType,
} from "../../pages/DashboardPage/vpo/api/vpo.config";
import { MyTask5WayFieldsRecordType, MyTask5WayFieldsType, MyTask5WayNameFields } from "./myTasks5Way.config";
import {
  MyTaskActionsListFieldsRecordType,
  MyTaskActionsListFieldsType,
  myTaskActionsListNameFields,
} from "./myTasksActions.config";
import { MyTaskAuditFieldsRecordType, MyTaskAuditFieldsType, MyTaskAuditNameFields } from "./myTasksAudit.config";
import { MyTaskListsFieldsRecordType, MyTaskListsFieldsType, MyTaskListsNameFields } from "./myTasksLists.config";
import { MyTaskIncFieldsRecordType, MyTaskIncFieldsType, MyTaskIncNameFields } from "./myTasksInc.config";
import { aiFieldsRecordType, aiFieldsType, aiNameFields } from "./ai.config";

export const emailsSender = true;
export const preprod = false; //флаг для препрода

export const siteUrl = preprod && "https://supply-preprod.napitkivmeste.ru" || "https://supply-mobile.napitkivmeste.ru";
export const strapiAPIUrl = preprod && "https://supply-preprod.napitkivmeste.ru" || "https://supply-mobile.napitkivmeste.ru";

export const strapiMediaUrl = strapiAPIUrl + "/uploads/";
export const strapiAdminUrl = 'https://supply-strapi.napitkivmeste.ru';

export const s3cloudUrl = "https://supply-s3.napitkivmeste.ru";

export const strapiNewDomainAdminUrl = "https://supply-mobile.napitkivmeste.ru";


export const SINGULAR_NAMES = {
  Systems: "systems",
  Users: "users",
};

export const relativeSitePath = "/";
export const systemsListName = "Systems";
export const myDocumentsListName = "MyDocuments";
export const myDocumentsWithRelationsListName = "MyDocumentsRe";
export const myDocumentsOWDCalendarWithRelationsListName = "MyDocumentsOWDCalendarRe";
export const myDocumentsEmployeeReportRelationsListName = "MyDocumentsEmployeeReport";
export const favoriteDocumentsListName = "FavoriteDocuments";
export const myWorksDocumentsListName = "MyWorksDocuments";
export const typesListName = "Types";
export const sectorsListName = "Sectors";
export const favoriteFoldersListName = "FavoriteFolders";
export const favoriteFiltersListName = "FavoriteFilters";
export const processesListName = "Processes";
export const departmentsListName = "Departments";
export const collectionsListName = "Collections";
export const approversListName = "Approvers";
export const dependenciesListName = "Dependencies";
export const linesListName = "Lines";
export const approversDependenciesListName = "ApproversDependencies";
export const equipmentsByDocumentListName = "EquipmentsByDocument";
export const documentByCardFilesLibName = "DocumentsByCard";
export const approversCardDocumentListName = "ApproversCardDocument";

export const equipmentsListName = "Equipments";
export const contactsListName = "Contacts";
export const myTaskContactsListName = "MyTaskContacts";
export const historyByDocumentListName = "HistoryByDocument";
export const historyChangeFieldsDocumentListName = "HistoryChangeFieldsDocument";
export const instructionsFilesLibName = "Instructions";
export const myTaskInstructionsFilesLibName = "MyTaskInstructions";
export const settingsListName = "Settings";
export const myTaskSettingsListName = "MyTaskSettings";
export const usersListName = "Users";
export const usersByGroupListName = "UsersByGroup";
export const userDepartmentsListName = "UserDepartments";
export const paramsListName = "Params";
export const documentRegistryFilters = "DocumentRegistryFilters";
export const statusesListName = "Statuses";
export const versionsByDocumentListName = "VersionsByDocument";
export const versionsCardListName = "VersionsCard";
export const copiesCardDocumentListName = "CopiesCardDocument";
export const listsApproversListName = "ListsApprovers";
export const documentCodeIndexesListName = "DocumentCodeIndexes";
export const templatesLibName = "Templates";

export const activityAnalysisListName = "ActivityAnalysis";

export const VPOColumnsListName = "VPOColumns";
export const LicensesInActionCardListName = "LicensesInActionCard";
export const ViolationsGosInActionCardListName = "ViolationsGosInActionCard";
export const GOPListName = "GOPInActionCard";

export const VPODefaultRequirementConditionsListName = "VPODefaultRequirementConditions";

export const VPORequirementsConditionsListName = "VPORequirementsConditions";
export const VPOStatusQuestionnaireListName = "VPOStatusQuestionnaire";

export const ReportsQuestionaryListName = "ReportsQuestionary";

export const ReportRegionListName = "ReportRegion";

export const NewsListName = "News";
export const ReplacedListName = "Replaced";
export const MDWorkstationListName = "MDWorkstation";
export const userRolesListName = "UserRoles";
export const MT5SInconsistencyListName = "MT5SInconsistency";
type ListFieldsEnumType = Record<string, FIELDS_TYPES>;

export const listFields: Record<string, ListFieldsEnumType> = {
  [MT5SInconsistencyListName]: {
    ID: FIELDS_TYPES.ID,
    Description: FIELDS_TYPES.STRING,
  },
  ...myTaskActionsListNameFields,
  ...myTaskMeetingsMainListFields,
  ...notificationsListFields,
  ...emailListFields,
  ...myVPOActionListNameFields,
  ...MyTaskListsNameFields,
  ...MyTaskAuditNameFields,
  ...MyTask5WayNameFields,
  ...MyGoslistNameFields,
  ...MyTaskIncNameFields,
  ...aiNameFields,
  [userRolesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Key: FIELDS_TYPES.STRING,
    MTLocation: FIELDS_TYPES.LOOKUP,
    Role: FIELDS_TYPES.STRING,
    MDCollection: FIELDS_TYPES.LOOKUP,
    Users: FIELDS_TYPES.MULTI_USER,
    AdGroupName: FIELDS_TYPES.STRING,
    Owners: FIELDS_TYPES.MULTI_USER,
    StrapiRole: FIELDS_TYPES.STRING,
  },
  [MDWorkstationListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Workstation: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    User: FIELDS_TYPES.MULTI_USER,
    SAP: FIELDS_TYPES.LOOKUP,
  },
  [ReplacedListName]: {
    ID: FIELDS_TYPES.ID,
    WhoReplaced: FIELDS_TYPES.USER,
    WhomReplaced: FIELDS_TYPES.USER,
    StartReplace: FIELDS_TYPES.DATE,
    EndReplace: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
  },
  [activityAnalysisListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    isVisit: FIELDS_TYPES.BOOLEAN,
    isActive: FIELDS_TYPES.BOOLEAN,
    DocumentCode: FIELDS_TYPES.STRING,
    Document: FIELDS_TYPES.LOOKUP,
    Author: FIELDS_TYPES.USER,
    Created: FIELDS_TYPES.DATE,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    ActiveType: FIELDS_TYPES.MULTI_STRING,
  },
  [NewsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Description: FIELDS_TYPES.STRING,
    Gallery: FIELDS_TYPES.MULTI_LOOKUP,
    VideoFrame: FIELDS_TYPES.STRING,
    LinksList: FIELDS_TYPES.MULTI_LOOKUP,
    PostImage: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
  },
  [paramsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Key: FIELDS_TYPES.STRING,
    Value: FIELDS_TYPES.STRING,
    ParamsType: FIELDS_TYPES.CHOICE,
    Comments: FIELDS_TYPES.STRING,
  },
  [approversDependenciesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    DocType: FIELDS_TYPES.LOOKUP,
    Collection: FIELDS_TYPES.LOOKUP,
    Group: FIELDS_TYPES.LOOKUP,
    Users: FIELDS_TYPES.MULTI_USER,
    Order0: FIELDS_TYPES.NUMBER,
    DefaultApprovers: FIELDS_TYPES.MULTI_USER,
    NotChange: FIELDS_TYPES.BOOLEAN,
  },
  [settingsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Path: FIELDS_TYPES.LINK,
    Description: FIELDS_TYPES.STRING,
    PathUrl: FIELDS_TYPES.STRING,
    IconUrl: FIELDS_TYPES.LINK,
    UsersGroup: FIELDS_TYPES.MULTI_USER,
  },
  [myTaskSettingsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Path: FIELDS_TYPES.LINK,
    Description: FIELDS_TYPES.STRING,
    IconUrl: FIELDS_TYPES.LINK,
    UsersGroup: FIELDS_TYPES.MULTI_USER,
  },
  [documentCodeIndexesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Index: FIELDS_TYPES.NUMBER,
  },
  [userDepartmentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
  },
  [usersListName]: {
    Title: FIELDS_TYPES.STRING,
    DisplayName: FIELDS_TYPES.STRING,
    PersonalNumber: FIELDS_TYPES.NUMBER,
    Department: FIELDS_TYPES.MULTI_STRING,
    Position: FIELDS_TYPES.MULTI_STRING,
    Email: FIELDS_TYPES.STRING,
    UserID: FIELDS_TYPES.NUMBER,
    ID: FIELDS_TYPES.ID,
  },
  [usersByGroupListName]: {
    Title: FIELDS_TYPES.STRING,
    Users: FIELDS_TYPES.MULTI_STRING,
    ID: FIELDS_TYPES.ID,
  },
  [copiesCardDocumentListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    CopyNum: FIELDS_TYPES.STRING,
    From: FIELDS_TYPES.USER,
    For: FIELDS_TYPES.USER,
    DateIssue: FIELDS_TYPES.DATE,
    Take: FIELDS_TYPES.DATE,
    Comment: FIELDS_TYPES.STRING,
    DocumentID: FIELDS_TYPES.NUMBER,
  },
  [statusesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [instructionsFilesLibName]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
  },
  [myTaskInstructionsFilesLibName]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
  },
  [contactsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Phone: FIELDS_TYPES.STRING,
    Email: FIELDS_TYPES.STRING,
  },
  [myTaskContactsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Phone: FIELDS_TYPES.STRING,
    Email: FIELDS_TYPES.STRING,
  },
  [historyChangeFieldsDocumentListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Comment: FIELDS_TYPES.STRING,
    JSONChangesFields: FIELDS_TYPES.STRING,
    DocumentID: FIELDS_TYPES.NUMBER,
    Approvers: FIELDS_TYPES.MULTI_USER,
    Statuses: FIELDS_TYPES.MULTI_LOOKUP,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    Author: FIELDS_TYPES.USER,
    ImportAuthor: FIELDS_TYPES.USER,
    Modified: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    ChangeDate: FIELDS_TYPES.DATE,
    ChangeRights: FIELDS_TYPES.USER,
  },
  [historyByDocumentListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Comment: FIELDS_TYPES.STRING,
    JSONChangesFields: FIELDS_TYPES.STRING,
    DocumentID: FIELDS_TYPES.NUMBER,
    ApprovalGroup: FIELDS_TYPES.LOOKUP,
    Approved: FIELDS_TYPES.USER,
    Denied: FIELDS_TYPES.USER,
    Approvers: FIELDS_TYPES.MULTI_USER,
    Statuses: FIELDS_TYPES.MULTI_LOOKUP,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    Modified: FIELDS_TYPES.DATE,
    ChangeDate: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    ChangeRights: FIELDS_TYPES.USER,
    Author: FIELDS_TYPES.USER,
  },
  [myDocumentsListName]: {
    PublicationDate: FIELDS_TYPES.DATE,
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    CollectionID: FIELDS_TYPES.NUMBER,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    Modified: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.MULTI_STRING,
    Import: FIELDS_TYPES.BOOLEAN,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [myDocumentsWithRelationsListName]: {
    PublicationDate: FIELDS_TYPES.DATE,
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    CollectionID: FIELDS_TYPES.NUMBER,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    Modified: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.MULTI_STRING,
    Import: FIELDS_TYPES.BOOLEAN,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [myDocumentsOWDCalendarWithRelationsListName]: {
    PublicationDate: FIELDS_TYPES.DATE,
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    CollectionID: FIELDS_TYPES.NUMBER,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    Modified: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.MULTI_STRING,
    Import: FIELDS_TYPES.BOOLEAN,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [myDocumentsEmployeeReportRelationsListName]: {
    PublicationDate: FIELDS_TYPES.DATE,
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    CollectionID: FIELDS_TYPES.NUMBER,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    Modified: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.MULTI_STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.MULTI_STRING,
    Import: FIELDS_TYPES.BOOLEAN,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [versionsCardListName]: {
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    PublicationDate: FIELDS_TYPES.DATE,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    MainDocument: FIELDS_TYPES.LOOKUP,
    Modified: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    Created: FIELDS_TYPES.DATE,
    AuthorEmail: FIELDS_TYPES.STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.STRING,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [versionsByDocumentListName]: {
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ResponsibleForRevision: FIELDS_TYPES.USER,
    PublicationDate: FIELDS_TYPES.DATE,
    Critical: FIELDS_TYPES.BOOLEAN,
    Path: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
    Lines: FIELDS_TYPES.MULTI_STRING,
    Equipments: FIELDS_TYPES.MULTI_STRING,
    DateForRevision: FIELDS_TYPES.DATE,
    MainDocument: FIELDS_TYPES.LOOKUP,
    Modified: FIELDS_TYPES.DATE,
    Index: FIELDS_TYPES.STRING,
    Created: FIELDS_TYPES.DATE,
    AuthorEmail: FIELDS_TYPES.STRING,
    ResponsibleForRevisionEmail: FIELDS_TYPES.STRING,
    Ver: FIELDS_TYPES.NUMBER,
    WorkPlaces: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [myWorksDocumentsListName]: {
    Code: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    VersionID: FIELDS_TYPES.NUMBER,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    DocType: FIELDS_TYPES.LOOKUP,
    ApproversList: FIELDS_TYPES.SKIP,
    SentForApproval: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Status: FIELDS_TYPES.LOOKUP,
  },
  [favoriteDocumentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Author: FIELDS_TYPES.USER,
    Document: FIELDS_TYPES.NUMBER,
  },
  [equipmentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    SAP: FIELDS_TYPES.STRING,
    Manufacturer: FIELDS_TYPES.STRING,
    Model: FIELDS_TYPES.STRING,
    TypeEquipment: FIELDS_TYPES.STRING,
    Collection: FIELDS_TYPES.MULTI_STRING,
  },
  [approversCardDocumentListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Approvers: FIELDS_TYPES.MULTI_USER,
    Document: FIELDS_TYPES.NUMBER,
    Group: FIELDS_TYPES.LOOKUP,
    Statuses: FIELDS_TYPES.MULTI_LOOKUP,
    Author: FIELDS_TYPES.USER,
    Approved: FIELDS_TYPES.USER,
    Denied: FIELDS_TYPES.USER,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    Queue: FIELDS_TYPES.BOOLEAN,
    Editor: FIELDS_TYPES.USER,
    Created: FIELDS_TYPES.DATE,
    MultiApprove: FIELDS_TYPES.BOOLEAN,
    MultiApproved: FIELDS_TYPES.MULTI_USER,
    MultiDenied: FIELDS_TYPES.MULTI_USER,
  },
  [documentByCardFilesLibName]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    ForHistory: FIELDS_TYPES.BOOLEAN,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    Created: FIELDS_TYPES.DATE,
  },
  [templatesLibName]: {
    ID: FIELDS_TYPES.ID,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    TemplateType: FIELDS_TYPES.LOOKUP,
    TemplateDate: FIELDS_TYPES.DATE,
    SortColumn: FIELDS_TYPES.NUMBER,
  },
  [listsApproversListName]: {
    ID: FIELDS_TYPES.ID,
    DocumentID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
  },
  [equipmentsByDocumentListName]: {
    ID: FIELDS_TYPES.ID,
    Line: FIELDS_TYPES.LOOKUP,
    Equipment: FIELDS_TYPES.LOOKUP,
    Document: FIELDS_TYPES.NUMBER,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
  },
  [linesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [systemsListName]: {
    Title: FIELDS_TYPES.STRING,
    IconUrl: FIELDS_TYPES.LINK,
    ID: FIELDS_TYPES.ID,
    Sort_ID: FIELDS_TYPES.NUMBER,
    Description: FIELDS_TYPES.STRING,
    ExternalLink: FIELDS_TYPES.STRING,
  },
  [favoriteFoldersListName]: {
    Title: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    ID: FIELDS_TYPES.ID,
    DocumentsFolder: FIELDS_TYPES.STRING,
    DocumentsCount: FIELDS_TYPES.NUMBER,
  },
  [favoriteFiltersListName]: {
    Title: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    ID: FIELDS_TYPES.ID,
    MDFilter: FIELDS_TYPES.STRING,
    Type: FIELDS_TYPES.CHOICE,
    DefaultFilter: FIELDS_TYPES.BOOLEAN,
    DisplayFilters: FIELDS_TYPES.STRING,
    MDFullFilters: FIELDS_TYPES.STRING,
    DocumentsFilter: FIELDS_TYPES.STRING,
    isDefault: FIELDS_TYPES.BOOLEAN
  },
  [documentRegistryFilters]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    DocumentsFilters: FIELDS_TYPES.STRING,
    Filters: FIELDS_TYPES.STRING,
    Creator: FIELDS_TYPES.STRING,
    DisplayFilters: FIELDS_TYPES.STRING,
  },
  [typesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Hide: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [sectorsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [processesListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [departmentsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
    User_Department: FIELDS_TYPES.STRING,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [collectionsListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
    Groups: FIELDS_TYPES.MULTI_USER,
    isPrivate: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER
  },
  [approversListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Code: FIELDS_TYPES.STRING,
    SortColumn: FIELDS_TYPES.NUMBER,
  },
  [dependenciesListName]: {
    ID: FIELDS_TYPES.ID,
    Collection: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    Sector: FIELDS_TYPES.LOOKUP,
  },
  [VPOColumnsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    MultiLineTitle: FIELDS_TYPES.STRING,
    ContentTypeId: FIELDS_TYPES.STRING,
    FileRef: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Subdivisions: FIELDS_TYPES.MULTI_LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    ProcessIndicator: FIELDS_TYPES.LOOKUP,
    ProcessIndicatorText: FIELDS_TYPES.STRING,
    StartDate1: FIELDS_TYPES.DATE,
    FinishDate: FIELDS_TYPES.DATE,
    LevelMaturity: FIELDS_TYPES.LOOKUP,
    RelationContent: FIELDS_TYPES.STRING,
    DopInfoContent: FIELDS_TYPES.STRING,
    SortNumber: FIELDS_TYPES.NUMBER,
    FolderName: FIELDS_TYPES.STRING,
  },
  [VPODefaultRequirementConditionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    FileRef: FIELDS_TYPES.STRING,
    Condition: FIELDS_TYPES.CHOICE,
    Subdivision: FIELDS_TYPES.LOOKUP,
  },
  [VPORequirementsConditionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Condition: FIELDS_TYPES.LOOKUP,
    Subdivision: FIELDS_TYPES.LOOKUP,
    Requirement: FIELDS_TYPES.LOOKUP,
    GroupRequirementID: FIELDS_TYPES.STRING,
    GroupRequirementFileRef: FIELDS_TYPES.STRING,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    FactoryID: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
  },
  [VPOStatusQuestionnaireListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ColumnID: FIELDS_TYPES.STRING,
    ColumnTitle: FIELDS_TYPES.STRING,
    GroupID: FIELDS_TYPES.STRING,
    GroupTitle: FIELDS_TYPES.STRING,
    FactoryID: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
    Status: FIELDS_TYPES.LOOKUP,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    CountYes: FIELDS_TYPES.STRING,
    CountQuestions: FIELDS_TYPES.STRING,
    CountNull: FIELDS_TYPES.STRING,
    Modified: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    IsError: FIELDS_TYPES.BOOLEAN,
    AutoEndDate: FIELDS_TYPES.DATE,
    AuthorEnd: FIELDS_TYPES.USER,
  },
  [ReportRegionListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ColumnID: FIELDS_TYPES.STRING,
    ColumnTitle: FIELDS_TYPES.STRING,
    GroupID: FIELDS_TYPES.STRING,
    GroupTitle: FIELDS_TYPES.STRING,
    FactoryID: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    CountYes: FIELDS_TYPES.STRING,
    CountQuestions: FIELDS_TYPES.STRING,
    CountNull: FIELDS_TYPES.STRING,
    SubdivisionID: FIELDS_TYPES.STRING,
    SubdivisionTitle: FIELDS_TYPES.STRING,
  },
  [LicensesInActionCardListName]: {
    ID: FIELDS_TYPES.ID,
  },
  [GOPListName]: {
    ID: FIELDS_TYPES.ID,
  },
  [ViolationsGosInActionCardListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ViolationText: FIELDS_TYPES.STRING,
    ParentFormId: FIELDS_TYPES.NUMBER,
  },
};

export type ListFieldsRecordType = {
  [MT5SInconsistencyListName]: {
    ID: number;
    Description: string;
  };
  [userRolesListName]: {
    ID: number;
    Title: string;
    Key: string;
    MTLocation: LookupFields;
    Role: string;
    MDCollection: LookupFields;
    Users: UserFields[];
    AdGroupName: string;
    Owners: UserFields[];
    StrapiRole: string;
  };
  [MDWorkstationListName]: {
    ID: number;
    Title: string;
    Workstation: string;
    Location: LookupFields;
    Department: LookupFields;
    User: UserFields[];
    SAP: LookupFields;
  };
  [ReplacedListName]: {
    ID: number;
    WhoReplaced: UserFields;
    WhomReplaced: UserFields;
    StartReplace: Date;
    EndReplace: Date;
    Created: Date;
  };
  [NewsListName]: {
    ID: number;
    Title: string;
    Description: string;
    Gallery: LookupFields[];
    VideoFrame: string;
    LinksList: LookupFields[];
    PostImage: LookupFields;
    Created: Date;
    Author: UserFields;
  };
  [paramsListName]: {
    ID: number;
    Title: string;
    Key: string;
    Value: string;
    ParamsType: string;
    Comments: string;
  };
  [settingsListName]: {
    Title: string;
    ID: number;
    Path: UrlFields;
    IconUrl: UrlFields;
    Description: string;
  };
  [myTaskSettingsListName]: {
    Title: string;
    ID: number;
    Path: UrlFields;
    IconUrl: UrlFields;
    Description: string;
    UsersGroup: UserFields[];
  };
  [userDepartmentsListName]: {
    Title: string;
    ID: number;
  };
  [activityAnalysisListName]: {
    ID: number;
    Title: string;
    isVisit: boolean;
    isActive: boolean;
    DocumentCode: string;
    Document: LookupFields;
    Created: Date;
    Author: UserFields;
    AuthorEmail: string;
    ActiveType: string;
  };
  [documentCodeIndexesListName]: {
    Title: string;
    ID: number;
    Index: number;
  };
  [approversDependenciesListName]: {
    Title: string;
    ID: number;
    DocType: LookupFields;
    Collection: LookupFields;
    Group: LookupFields;
    Users: UserFields[];
    Order0: number;
    DefaultApprovers: UserFields[];
    NotChange: boolean;
  };
  [usersListName]: {
    Title: string;
    DisplayName: string;
    PersonalNumber: number;
    Department: string;
    Position: string;
    Email: string;
    UserID: number;
    ID: number;
  };
  [usersByGroupListName]: {
    Title: string;
    Users: string;
    ID: number;
  };
  [statusesListName]: {
    Title: string;
    ID: number;
  };
  [instructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [myTaskInstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [contactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [myTaskContactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [historyChangeFieldsDocumentListName]: {
    ID: number;
    Title: string;
    Comment: string;
    JSONChangesFields: string;
    DocumentID: number;
    Approvers: UserFields[];
    Statuses: LookupFields[];
    VersionDocument: boolean;
    Author: UserFields;
    ImportAuthor: UserFields;
    Modified: Date;
    Created: Date;
    ChangeDate: Date;
    ChangeRights: UserFields;
  };
  [copiesCardDocumentListName]: {
    ID: number;
    Title: string;
    CopyNum: string;
    From: UserFields;
    For: UserFields;
    DateIssue: Date;
    Take: Date;
    DocumentID: number;
    Comment: string;
  };
  [historyByDocumentListName]: {
    ID: number;
    Title: string;
    Comment: string;
    JSONChangesFields: string;
    DocumentID: number;
    ApprovalGroup: LookupFields;
    Approved: UserFields | null;
    Denied: UserFields | null;
    Approvers: UserFields[];
    Statuses: LookupFields[];
    VersionDocument: boolean;
    Modified: Date;
    Created: Date;
    ChangeDate: Date;
    ChangeRights: UserFields | null;
    Author: UserFields;
  };
  [favoriteDocumentsListName]: {
    Title: string;
    ID: number;
    Author: UserFields;
    Document: number;
  };

  [myDocumentsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [myDocumentsWithRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [myDocumentsOWDCalendarWithRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [myDocumentsEmployeeReportRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [versionsCardListName]: {
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    MainDocument: LookupFields;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [versionsByDocumentListName]: {
    Code: string;
    Title: string;
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Sector: LookupFields;
    Process: LookupFields;
    DocType: LookupFields;
    ResponsibleForRevision: UserFields;
    PublicationDate: Date;
    Critical: boolean;
    Path: string;
    Author: UserFields;
    Status: LookupFields;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Date;
    MainDocument: LookupFields;
    Modified: Date;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Ver: number;
    WorkPlaces: LookupFields[];
  };
  [myWorksDocumentsListName]: {
    Code: string;
    Title: string;
    ID: number;
    VersionID: number;
    Collection: LookupFields;
    Department: LookupFields;
    DocType: LookupFields;
    SentForApproval: Date;
    ApproversList: UserFields[];
    Author: UserFields;
    Status: LookupFields;
  };
  [equipmentsListName]: {
    Title: string;
    ID: number;
    SAP: string;
    Manufacturer: string;
    Model: string;
    TypeEquipment: string;
    Collection: string;
  };
  [approversCardDocumentListName]: {
    ID: number;
    Title: string;
    Approvers: UserFields[];
    Document: number;
    Group: LookupFields;
    Statuses: LookupFields[];
    Author: UserFields;
    Approved: UserFields | null;
    Denied: UserFields | null;
    VersionDocument: boolean;
    Queue: boolean;
    Created: Date;
    Editor: UserFields;
  };
  [documentByCardFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    ForHistory: boolean;
    VersionDocument: boolean;
    Created: Date;
  };
  [templatesLibName]: {
    ID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    TemplateType: LookupFields;
    TemplateDate: Date;
    SortColumn: number;
  };
  [listsApproversListName]: {
    ID: number;
    DocumentID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [dependenciesListName]: {
    ID: number;
    Collection: LookupFields;
    Department: LookupFields;
    Process: LookupFields;
    Sector: LookupFields;
  };
  [equipmentsByDocumentListName]: {
    ID: number;
    Line: LookupFields;
    Equipment: LookupFields;
    Equipment_x003a_Title: LookupFields;
    Equipment_x003a_Manufacturer: LookupFields;
    Equipment_x003a_Model: LookupFields;
    Equipment_x003a_TypeEquipment: LookupFields;
    Document: number;
    VersionDocument: boolean;
  };
  [linesListName]: {
    Title: string;
    ID: number;
    Collection: LookupFields;
    Hide: boolean;
    SortColumn: number;
  };
  [systemsListName]: {
    Title: string;
    IconUrl: UrlFields;
    ExternalLink: UrlFields;
    ID: number;
    Sort_ID: number;
    Description: string;
  };
  [favoriteFoldersListName]: {
    Title: string;
    Author: UserFields;
    ID: number;
    DocumentsFolder: string;
    DocumentsCount: number;
  };
  [favoriteFiltersListName]: {
    Title: string;
    Author: UserFields;
    ID: number;
    MDFilter: string;
    Type: string;
    DefaultFilter: boolean;
    DisplayFilters: string;
    MDFullFilters: string;
    DocumentsFilter: string;
    isDefault: boolean;
  },
  [documentRegistryFilters]: {
    Title: string;
    ID: number;
    DocumentsFilters: string;
    Filters: string;
    DisplayFilters: string;
    Creator: string;
  };
  [typesListName]: {
    Title: string;
    ID: number;
    Hide: boolean;
    SortColumn: number;
  };
  [sectorsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    SortColumn: number;
  };
  [processesListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    SortColumn: number;
  };
  [departmentsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    User_Department: string;
    SortColumn: number;
  };
  [collectionsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    Groups: UserFields[];
    isPrivate: boolean;
    SortColumn: number;
  };
  [approversListName]: {
    ID: number;
    Title: string;
    Code: string;
    SortColumn: number;
  };
  [LicensesInActionCardListName]: {
    ID: number;
  };
  [GOPListName]: {
    ID: number;
  };
  [ViolationsGosInActionCardListName]: {
    ID: number;
    Title: string;
    ViolationText: string;
    ParentFormId: number;
  };
} & MyTaskMeetingsMainListFieldsRecordType &
  NotificationsListFieldsRecordType &
  EmailListFieldsRecordType &
  MyTaskActionsListFieldsRecordType &
  myVPOActionListNameFieldsRecordType &
  MyTaskListsFieldsRecordType &
  MyTaskAuditFieldsRecordType &
  MyTask5WayFieldsRecordType &
  MyGoslistNameFieldsRecordType &
  MyTaskIncFieldsRecordType &
  aiFieldsRecordType;

export type ListFieldsType = {
  [MT5SInconsistencyListName]: {
    ID: number;
    Description: string;
  };
  [userRolesListName]: {
    ID: number;
    Title: string;
    Key: string;
    MTLocation: LookUpRecord;
    Role: string;
    MDCollection: LookUpRecord;
    Users: UserRecord[];
    AdGroupName: string;
    Owners: UserRecord[];
    StrapiRole: string;
  };
  [MDWorkstationListName]: {
    ID: number;
    Title: string;
    Workstation: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    User: UserRecord[];
    SAP: LookUpRecord;
  };
  [ReplacedListName]: {
    ID: number;
    WhoReplaced: UserRecord;
    WhomReplaced: UserRecord;
    StartReplace: Date;
    EndReplace: Date;
    Created: Date;
  };
  [NewsListName]: {
    ID: number;
    Title: string;
    Description: string;
    Gallery: LookUpRecord[];
    VideoFrame: string;
    LinksList: LookUpRecord[];
    PostImage: LookUpRecord;
    Created: Date;
    Author: UserRecord;
  };
  [activityAnalysisListName]: {
    ID: number;
    Title: string;
    isVisit: boolean;
    isActive: boolean;
    DocumentCode: string;
    Document: LookUpRecord;
    Created: Moment;
    Author: UserRecord;
    AuthorEmail: string;
    ActiveType: string;
  };
  [paramsListName]: {
    ID: number;
    Title: string;
    Key: string;
    Value: string;
    ParamsType: string;
    Comments: string;
  };
  [settingsListName]: {
    Title: string;
    ID: number;
    Path: string;
    IconUrl: string;
    Description: string;
  };
  [myTaskSettingsListName]: {
    Title: string;
    ID: number;
    Path: string;
    IconUrl: string;
    Description: string;
    UsersGroup: UserRecord[];
  };
  [userDepartmentsListName]: {
    Title: string;
    ID: number;
  };
  [documentCodeIndexesListName]: {
    Title: string;
    ID: number;
    Index: number;
  };
  [approversDependenciesListName]: {
    Title: string;
    ID: number;
    DocType: LookUpRecord;
    Collection: LookUpRecord;
    Group: LookUpRecord;
    Users: UserRecord[];
    Order0: number;
    DefaultApprovers: UserRecord[];
    NotChange: boolean;
  };
  [usersListName]: {
    Title: string;
    DisplayName: string;
    PersonalNumber: number;
    Department: string;
    Position: string;
    Email: string;
    UserID: number;
    ID: number;
  };
  [usersByGroupListName]: {
    Title: string;
    Users: string;
    ID: number;
  };
  [statusesListName]: {
    Title: string;
    ID: number;
  };
  [instructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [myTaskInstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [contactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [myTaskContactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [favoriteDocumentsListName]: {
    Title: string;
    ID: number;
    Author: UserRecord;
    Document: number;
  };
  [historyChangeFieldsDocumentListName]: {
    ID: number;
    Title: string;
    Comment: string;
    DocumentID: number;
    JSONChangesFields: string;
    Approvers: UserRecord[];
    Statuses: LookUpRecord[];
    VersionDocument: boolean;
    Author: UserRecord;
    ImportAuthor: UserRecord;
    Modified: Date;
    Created: Date;
    ChangeDate: Date;
    ChangeRights: UserRecord;
  };
  [copiesCardDocumentListName]: {
    ID: number;
    DocumentID: number;
    Title: string;
    CopyNum: string;
    From: UserRecord;
    For: UserRecord;
    DateIssue: Moment;
    Take: Moment;
    Comment: string;
  };
  [historyByDocumentListName]: {
    ID: number;
    Title: string;
    Comment: string;
    DocumentID: number;
    JSONChangesFields: string;
    Approved: UserRecord | null;
    Denied: UserRecord | null;
    Approvers: UserRecord[];
    ApprovalGroup: LookUpRecord;
    Statuses: LookUpRecord[];
    VersionDocument: boolean;
    Modified: Moment;
    Created: Moment;
    ChangeDate: Moment;
    ChangeRights: UserRecord | null;
    Author: UserRecord;
  };
  [myDocumentsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    Modified: Moment;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };
  [myDocumentsWithRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    Modified: Moment;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };
  [myDocumentsOWDCalendarWithRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    Modified: Moment;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };
  [myDocumentsEmployeeReportRelationsListName]: {
    CollectionID: number;
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    Modified: Moment;
    Index: string;
    Created: Date;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Import: boolean;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };
  [versionsCardListName]: {
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    MainDocument: LookUpRecord;
    Modified: Moment;
    Index: string;
    Created: Moment;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };

  [versionsByDocumentListName]: {
    Code: string;
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Sector: LookUpRecord;
    Process: LookUpRecord;
    DocType: LookUpRecord;
    ResponsibleForRevision: UserRecord;
    PublicationDate: Moment;
    Critical: boolean;
    Path: string;
    Author: UserRecord;
    Status: LookUpRecord;
    Lines: string[];
    Equipments: string[];
    DateForRevision: Moment;
    MainDocument: LookUpRecord;
    Modified: Moment;
    Index: string;
    Created: Moment;
    AuthorEmail: string;
    ResponsibleForRevisionEmail: string;
    Ver: number;
    WorkPlaces: LookUpRecord[];
  };
  [myWorksDocumentsListName]: {
    Code: string;
    Title: string;
    ID: number;
    VersionID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    DocType: LookUpRecord;
    SentForApproval: Date;
    ApproversList: UserRecord[];
    Author: UserRecord;
    Status: LookUpRecord;
  };
  [equipmentsListName]: {
    Title: string;
    ID: number;
    SAP: string;
    Manufacturer: string;
    Model: string;
    TypeEquipment: string;
    Collection: string;
  };
  [approversCardDocumentListName]: {
    ID: number;
    Title: string;
    Approvers: UserRecord[];
    Document: number;
    Group: LookUpRecord;
    Statuses: LookUpRecord[];
    Author: UserRecord;
    Approved: UserRecord | null;
    Denied: UserRecord | null;
    VersionDocument: boolean;
    Queue: boolean;
    Created: Moment;
    Editor: UserRecord;
    MultiApprove: boolean;
    MultiApproved: UserRecord[];
    MultiDenied: UserRecord[];
  };
  [documentByCardFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    ForHistory: boolean;
    VersionDocument: boolean;
    Created: Moment;
  };
  [templatesLibName]: {
    ID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    TemplateType: LookUpRecord;
    TemplateDate: Date;
    SortColumn: number;
  };
  [listsApproversListName]: {
    ID: number;
    DocumentID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [dependenciesListName]: {
    ID: number;
    Collection: LookUpRecord;
    Department: LookUpRecord;
    Process: LookUpRecord;
    Sector: LookUpRecord;
  };
  [linesListName]: {
    Title: string;
    ID: number;
    Collection: LookUpRecord;
    Hide: boolean;
    SortColumn: number;
  };
  [systemsListName]: {
    Title: string;
    IconUrl: string;
    ExternalLink: string;
    ID: number;
    Sort_ID: number;
    Description: string;
  };
  [favoriteFoldersListName]: {
    Title: string;
    Author: UserRecord;
    ID: number;
    DocumentsFolder: string;
    DocumentsCount: number;
  };
  [favoriteFiltersListName]: {
    Title: string;
    Author: UserRecord;
    ID: number;
    MDFilter: string;
    Type: string;
    DefaultFilter: boolean;
    DisplayFilters: string;
    MDFullFilters: string;
    DocumentsFilter: string;
    isDefault: boolean;
  },
  [documentRegistryFilters]: {
    Title: string;
    ID: number;
    DocumentsFilters: string;
    Filters: string;
    DisplayFilters: string;
    Creator: string;
  };
  [typesListName]: {
    Title: string;
    ID: number;
    Hide: boolean;
    SortColumn: number
  };
  [sectorsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    SortColumn: number
  };
  [processesListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    SortColumn: number;
  };
  [departmentsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    User_Department: string;
    SortColumn: number;
  };
  [collectionsListName]: {
    Title: string;
    ID: number;
    Code: string;
    Hide: boolean;
    Groups: UserRecord[];
    isPrivate: boolean;
    SortColumn: number;
  };
  [approversListName]: {
    ID: number;
    Title: string;
    Code: string;
    SortColumn: number;
  };
  [equipmentsByDocumentListName]: {
    ID: number;
    Line: LookUpRecord;
    Equipment: LookUpRecord;
    Equipment_x003a_Title: LookUpRecord;
    Equipment_x003a_Manufacturer: LookUpRecord;
    Equipment_x003a_Model: LookUpRecord;
    Equipment_x003a_TypeEquipment: LookUpRecord;
    Document: number;
    VersionDocument: boolean;
  };
  [LicensesInActionCardListName]: {
    ID: number;
  };
  [GOPListName]: {
    ID: number;
  };
  [ViolationsGosInActionCardListName]: {
    ID: number;
    Title: string;
    ViolationText: string;
    ParentFormId: number;
  };
} & MyTaskMeetingsMainListFieldsType &
  NotificationsListFieldsType &
  EmailListFieldsType &
  MyTaskActionsListFieldsType &
  myVPOActionListNameFieldsType &
  MyTaskListsFieldsType &
  MyTaskAuditFieldsType &
  MyTask5WayFieldsType &
  MyGoslistNameFieldsType &
  MyTaskIncFieldsType &
  aiFieldsType;

export type ListFieldsKeys = keyof ListFieldsType;

//ID FOLDERS IN STRAPI

export const MTAuditFiles = {
  idFolder: "9",
  apiStrapi: "mt-audit-files",
  createElemInStrapi: true,
};
export const MTIncCommentsFiles = {
  idFolder: "20",
  apiStrapi: "mt-inc-comments-files",
  createElemInStrapi: true,
};
export const MTActionCommentsFiles = {
  idFolder: "6",
  apiStrapi: "mt-action-comments-files",
  createElemInStrapi: true,
};
export const MTCheckListCommentsFiles = {
  idFolder: "26",
  apiStrapi: "mt-check-list-tasks-comments-files",
  createElemInStrapi: true,
};
export const MT5WhyCommentsFiles = {
  idFolder: "19",
  apiStrapi: "mt-5-way-comments-files",
  createElemInStrapi: true,
};
export const MDListsApproversFiles = {
  idFolder: "13",
  apiStrapi: "lists-approvers",
  createElemInStrapi: true,
};
export const MDDocumentsFiles = {
  idFolder: "4",
  apiStrapi: "md-documents-file",
  createElemInStrapi: true,
};
